import React from 'react';
import { useLanguage } from '../services/LanguageContext';

const BrazilFlag = () => (
  <svg width="16" height="11" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="14" rx="2" fill="#009B3A"/>
    <path d="M10 2L18 7L10 12L2 7L10 2Z" fill="#FEDF00"/>
    <circle cx="10" cy="7" r="2.8" fill="#002776"/>
    <path d="M7.5 7.8C7.5 7.8 8.5 6.5 10 6.5C11.5 6.5 12.5 7.8 12.5 7.8" stroke="#fff" strokeWidth="0.4" fill="none"/>
  </svg>
);

const USAFlag = () => (
  <svg width="16" height="11" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="14" rx="2" fill="#fff"/>
    <rect y="0" width="20" height="1.077" fill="#B22234"/>
    <rect y="2.154" width="20" height="1.077" fill="#B22234"/>
    <rect y="4.308" width="20" height="1.077" fill="#B22234"/>
    <rect y="6.462" width="20" height="1.077" fill="#B22234"/>
    <rect y="8.615" width="20" height="1.077" fill="#B22234"/>
    <rect y="10.769" width="20" height="1.077" fill="#B22234"/>
    <rect y="12.923" width="20" height="1.077" fill="#B22234"/>
    <rect width="8" height="7.538" fill="#3C3B6E"/>
  </svg>
);

/**
 * Selector de idioma inline para dentro do modal do produto.
 * Só é renderizado quando o produto tem tradução (nome_en preenchido).
 */
function LanguageSelector({ produto }) {
  const { idioma, alterarIdioma } = useLanguage();

  if (!produto || !produto.nome_en) return null;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      marginBottom: '10px',
    }}>
      <button
        type="button"
        onClick={() => alterarIdioma('pt')}
        style={{
          border: 'none',
          borderRadius: '14px',
          padding: '4px 8px',
          fontSize: '11px',
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'all 0.2s',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          background: idioma === 'pt' ? '#111827' : '#f3f4f6',
          color: idioma === 'pt' ? '#ffffff' : '#6b7280',
        }}
        aria-label="Português"
      >
        <BrazilFlag /> PT
      </button>
      <button
        type="button"
        onClick={() => alterarIdioma('en')}
        style={{
          border: 'none',
          borderRadius: '14px',
          padding: '4px 8px',
          fontSize: '11px',
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'all 0.2s',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          background: idioma === 'en' ? '#111827' : '#f3f4f6',
          color: idioma === 'en' ? '#ffffff' : '#6b7280',
        }}
        aria-label="English"
      >
        <USAFlag /> EN
      </button>
    </div>
  );
}

export default LanguageSelector;
